
import { Component, Vue, Prop } from "vue-property-decorator";

import akt_routes from "@/api/routes/akt";

import NotificationNotification from "@/models/notification/notification";
import { IAssignmentUserWorkplaceInfo } from "@/models/akt/assignment_user_workplace";

@Component({
  name: "CAktReview"
})
export default class CAktReview extends Vue {
  @Prop({ required: true }) public notification!: NotificationNotification;

  public workplace: IAssignmentUserWorkplaceInfo | null = null;

  protected async created() {
    await this.loadTest();
  }

  private async loadTest() {
    return this.$api
      .get(akt_routes.get_workplace_info(this.notification.targetable_id))
      .then(({ data: res }: { data: IAssignmentUserWorkplaceInfo }) => {
        this.workplace = res;
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  public delegateAkt() {
    this.$emit("delegate", this.workplace);
  }

  public closeAkt() {
    this.$emit("close", true);
  }

  public showAkt() {
    this.$emit("onVisited", true);
  }
}
